import React from "react";
import { Link } from "react-router-dom";

// Shared editorial shell for the three legal pages.
// Keeps them visually consistent with the rest of the FIND LET site.
export const LegalPage = ({ eyebrow, title, lastUpdated, children }) => {
  return (
    <div className="bg-[#F9FBFF] text-[#091F5C]">
      {/* Header */}
      <section className="bg-white border-b border-[#E5EBF5]">
        <div className="max-w-4xl mx-auto px-6 lg:px-10 py-20 lg:py-24 space-y-6">
          {eyebrow && <span className="eyebrow">{eyebrow}</span>}
          <h1 className="display-hero text-4xl sm:text-5xl">{title}</h1>
          {lastUpdated && (
            <p className="text-xs text-[#4A5B78] tracking-wide font-light">
              Last updated: {lastUpdated}
            </p>
          )}
        </div>
      </section>

      {/* Body */}
      <section className="py-16 lg:py-20">
        <div className="max-w-3xl mx-auto px-6 lg:px-10 legal-body space-y-8">
          {children}
        </div>
      </section>

      {/* Cross-links to sibling legal pages */}
      <section className="pb-20">
        <div className="max-w-3xl mx-auto px-6 lg:px-10">
          <div className="border-t border-[#E5EBF5] pt-8 flex flex-wrap gap-6 text-xs text-[#4A5B78]">
            <span className="uppercase tracking-[0.22em] font-heading font-semibold text-[#334DAF]">See also</span>
            <Link to="/privacy" className="hover:text-[#091F5C] transition-colors">Privacy Policy</Link>
            <Link to="/terms" className="hover:text-[#091F5C] transition-colors">Terms &amp; Conditions</Link>
            <Link to="/aml" className="hover:text-[#091F5C] transition-colors">AML &amp; Financial Crime Policy</Link>
            <Link to="/contact" className="hover:text-[#091F5C] transition-colors">Contact the concierge desk</Link>
          </div>
        </div>
      </section>
    </div>
  );
};

// Small consistent heading + paragraph pair used inside every legal page
export const LegalSection = ({ heading, children }) => (
  <section className="space-y-3">
    <h2 className="text-lg lg:text-xl font-heading font-semibold text-[#091F5C]">{heading}</h2>
    <div className="space-y-3 text-sm text-[#4A5B78] font-light leading-relaxed">{children}</div>
  </section>
);
